// src/components/store/sections/hero-banner/HeroV8CathedralarchEmeraldMint.tsx
"use client";

import React from "react";
import DynamicHeroVariant from "./DynamicHeroVariant";

export default function HeroV8CathedralarchEmeraldMint(props: any) {
  return (
    <DynamicHeroVariant
      variantNumber={8}
      archKey="cathedral_arch"
      archLabel="Cathedral Arch Stage"
      palName="EmeraldMint"
      grad="from-emerald-500 via-teal-500 to-emerald-700"
      lightBg="bg-emerald-50"
      textCol="text-emerald-700"
      borderCol="border-emerald-200"
      btnCls="bg-emerald-600 hover:bg-emerald-700"
      {...props}
    />
  );
}
